import 'antd/dist/antd.variable.min.css';
import './layout_orange.css';
import zh_TW from 'antd/es/locale/zh_TW';
// layout_orange 是修改header sidebar 的地方
import { ConfigProvider } from 'antd';
ConfigProvider.config({
  theme: {
    primaryColor: '#BC6C25',
  },
});

